module.exports = __webpack_public_path__ + "/img/6b7f9d26879713c72cd2bec4820ed67d.png";